module.exports = __webpack_public_path__ + "media/components/assets/icons/sidebar_coupon-424f81ac7ea4c04f3d0c1b5ed60ed0b9.svg";